import { IAction } from "../model/IAction";

export const UPDATE_PROMOTE_RESULT_AS = "UPDATE_PROMOTE_RESULT_ACTION";
export function updatePromoteResultAs(elementId: string | undefined, promoteResultAs: string | null): UpdatePromoteResultAction {
  return {
    type: UPDATE_PROMOTE_RESULT_AS,
    elementId: elementId,
    promoteResultAs: promoteResultAs
  };
}
export interface UpdatePromoteResultAction extends IAction {
  elementId: string | undefined;
  promoteResultAs: string | null;
}
